import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectScrubbedAddress, selectUserInfo } from '@app/redux';

import { AccountType } from '@mfe/shared/schema-types';

import { formatAddressOnTwoLines } from '../utils/formatAddressOnTwoLines';
import { ScrubAddressProcessStatus, ScrubAddressRecommendation } from 'apps/platform/src/server/dataSources/PAL/types';

export const usePrepopulateContactInfo = () => {
  const { userInfo, loading } = useSelector(selectUserInfo);
  const { email, accountHolder, accountType } = userInfo;
  const shippingAddress = userInfo.address.shipping;

  const { scrubbedAddress } = useSelector(selectScrubbedAddress);
  const { rawAddress } = scrubbedAddress;
  const { addressLines, ...rest } = rawAddress;

  const isValid =
    scrubbedAddress.processStatus !== ScrubAddressProcessStatus.Incorrect ||
    scrubbedAddress.recommendation !== ScrubAddressRecommendation.REJECT;

  const hasValidUpdatedValues = isValid && Object.values(rest).some((val) => val);
  const updatedAddress = scrubbedAddress?.rawAddress;

  const shippingAddressValues: string[] = useMemo(
    () => formatAddressOnTwoLines(hasValidUpdatedValues ? updatedAddress : shippingAddress),
    [hasValidUpdatedValues, updatedAddress, shippingAddress]
  );

  return {
    address: shippingAddressValues,
    email: accountType === AccountType.Smb ? accountHolder.email : email,
    loading,
  };
};
